module.exports = __webpack_public_path__ + "static/media/IMG_20190818_184054.e060a4d9.jpg";